import React, { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../config';

const PasswordReset = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  const handlePasswordReset = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/api/password-reset/`, {
        email,
      });
      setSuccess(true);
      setMessage(response.data.detail || 'Falls ein Konto mit dieser E-Mail existiert, wurde ein Link gesendet.');
    } catch (error) {
      setSuccess(false);
      if (error.response && error.response.data) {
        const data = error.response.data;
        const msg = data.detail || data.error || data.message || JSON.stringify(data);
        setMessage(msg);
      } else if (error.request) {
        setMessage('Keine Antwort vom Server. Bitte versuche es erneut.');
      } else {
        setMessage(error.message);
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 className="auth-title">Passwort vergessen?</h2>
        <p className="auth-subtitle">Gib deine E-Mail ein und wir senden dir einen Link</p>
        <div className="mb-3">
          <label className="auth-label">E-Mail</label>
          <input
            type="email"
            className="form-control auth-input"
            placeholder="du@beispiel.de"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <button className="auth-btn" onClick={handlePasswordReset}>
          Link senden
        </button>
        {message && (
          <p className="auth-message" style={{ color: success ? '#2e7d32' : '#c62828' }}>
            {message}
          </p>
        )}
        <div className="auth-links" style={{ marginTop: '16px' }}>
          <a href="/login">Zurück zur Anmeldung</a>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
